<template>
  <div class="profile-container">
    <div class="nav-container">
      <div :class="themeColor" class="avatar-container">
        <app-avatar :size="128" :id="profileInfo.avatar" class="ma-3"/>
        <div class="title d-flex justify-center align-center mt-4 mb-4">
          <span class="mr-3">{{profileInfo.nickname}}</span>
          <span>{{profileInfo.role}}</span>
        </div>
        <div class="mt-1">版本: {{appVersion}}</div>
      </div>

      <v-navigation-drawer
        height="auto"
        permanent
        class="nav-list">
        <v-list>
          <router-link
            tag="v-list-tile"
            active-class="list-item--selected"
            :to="{name: n.routeName}"
            :key="index"
            v-for="(n, index) in navigationList"
            v-ripple>
            <v-list-tile-action>
              <v-tooltip right>
                <v-icon slot="activator">{{n.icon}}</v-icon>
                <span>{{n.text}}</span>
              </v-tooltip>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{n.text}}</v-list-tile-title>
            </v-list-tile-content>
          </router-link>
        </v-list>
      </v-navigation-drawer>
    </div>

    <transition name="fade" mode="out-in" type="transition">
      <router-view class="flex-grow"></router-view>
    </transition>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Profile',
  data() {
    return {
      navigations: [
        {icon: 'account_circle', text: '帳戶', routeName: 'Account', roles: ['student', 'teacher']},
        {icon: 'list', text: '使用紀錄', routeName: 'FudaoHistory', roles: ['student']},
        // {icon: 'list', text: '儲值紀錄', routeName: 'ChargeHistory', roles: ['student']},
        {icon: 'list', text: '收入紀錄', routeName: 'IncomeHistory', roles: ['teacher']}
        // {icon: 'list', text: '錯題紀錄', routeName: 'WrongAnswerHistory', roles: ['student']}
      ]
    };
  },

  computed: {
    ...mapGetters({
      profileInfo: 'profileInfo'
    }),

    appVersion() {
      return process.env.VUE_APP_VERSION;
    },

    navigationList() {
      return this.navigations.filter(n => {
        return this.isAllow(n.roles);
      });
    }
  },

  methods: {
  }
};
</script>

<style lang="stylus" scoped>

.profile-container {
  position: relative;
  display: flex;
  align-items: stretch;
  overflow: hidden;
}

.nav-container {
  overflow-y: auto;
  min-width: 250px;
  border-right: 1px solid darken($secondary-color, 10%);
  // background-color: $def-bg-color;
}

.avatar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
}

.nav-list {
  background-color: inherit;
}
</style>
